import ES_CONVERSION from "@/locales/es.conversion.json";
import ZH_CONVERSION from "@/locales/zh.conversion.json";
import RU_CONVERSION from "@/locales/ru.conversion.json";

export const CONVERSION_LOCALES = {
  es: ES_CONVERSION,
  zh: ZH_CONVERSION,
  ru: RU_CONVERSION,
};
